import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";

import { AuthContext } from "../AuthContext/AuthContext";
import { getLoginURL } from "../../Pantalla/helper/funciones";

const ProtectedRoute = (props) => {
  const { authenticated } = useContext(AuthContext);
  const { Component } = props;
 // console.log("PROTECTED ROUTE", getLoginURL());
  return (
    <Route
      path={props.path}
      name={props}
      render={
        authenticated
          ? (props) => <Component {...props} />
          : (location) => (
              <Redirect
                to={{
                  pathname: getLoginURL(),
                  state: { from: location },
                }}
              />
            )
      }
    />
  );
};

export default ProtectedRoute;
